@defer {
  <soft-rich-text-editor-core [content]="_content() ?? null" (contentChange)="contentChanged($event)">
    <ng-content></ng-content>
  </soft-rich-text-editor-core>
}
